import Cookies from 'js-cookie';

const BUCKET_MAX = 100;
const COOKIE_DAYS = 90;

export function readRolloutBucket(cookieName: string): number | undefined {
  const existing = Cookies.get(cookieName);
  if (existing === undefined || !/^\d+$/.test(existing)) return undefined;
  const bucket = Number(existing);
  if (bucket < 0 || bucket >= BUCKET_MAX) return undefined;
  return bucket;
}

export function getOrCreateRolloutBucket(cookieName: string): number {
  const existing = readRolloutBucket(cookieName);
  if (existing !== undefined) return existing;

  const bucket = createBucket();
  Cookies.set(cookieName, String(bucket), {
    expires: COOKIE_DAYS,
    path: '/',
    sameSite: 'Lax',
  });
  return bucket;
}

function createBucket(): number {
  const bytes = new Uint32Array(1);
  crypto.getRandomValues(bytes);

  return bytes[0] % BUCKET_MAX;
}
